module.exports = __webpack_public_path__ + "static/media/doa-zakat.c6671c0c.svg";